import {HttpClient} from './HttpClientInterface.js';
import {AxiosHttpClient} from './AxiosHttpClient.js';

export function create(): HttpClient {
  return new AxiosHttpClient();
}

export {Response} from './Response.js';
